/** 来源：foodbuy/market Panel；Card 为规范名。Panel/PanelHeading 别名已随六应用换名清零删除（LeapWorldUI-11）。 */
import type { HTMLAttributes, ReactNode } from 'react'

export type CardProps = HTMLAttributes<HTMLElement> & { children?: ReactNode; padded?: boolean }

export function Card({ children, className = '', padded = false, ...props }: CardProps) {
  return (
    <section
      className={`panel overflow-hidden rounded-[var(--radius-lg)] border border-[var(--color-line)] bg-[var(--color-panel)] shadow-[var(--shadow-card)] ${padded ? 'p-4 sm:p-5' : ''} ${className}`.trim()}
      {...props}
    >
      {children}
    </section>
  )
}

export function CardHeading({ title, description, action }: { title: ReactNode; description?: ReactNode; action?: ReactNode }) {
  return (
    <div className="flex flex-wrap items-start justify-between gap-3 border-b border-[var(--color-line)] bg-[var(--color-card-heading-bg)] px-5 pt-4 pb-3">
      <div className="min-w-0">
        <h2 className="m-0 text-[length:var(--text-card-heading)] font-semibold text-[var(--color-ink)] [overflow-wrap:anywhere]">{title}</h2>
        {description ? <p className="m-0 mt-1 text-[length:var(--text-caption)] leading-5 text-[var(--color-ink-secondary)] [overflow-wrap:anywhere]">{description}</p> : null}
      </div>
      {action}
    </div>
  )
}
